// @ts-ignore
export function timeFormater(datetime: Date) {
    // App Origin Format: hh:mm dd/mm/yyyy. Example: 09:06 06/02/2023
    let date = new Date(datetime);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let formattedDate = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes} ${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year}`;
    return formattedDate;
}

/** @function coordinateFeature : handle the result of coordinatesGeocoder function */
function coordinateFeature(lng: any, lat: any) {
    return {
        center: [lng, lat],
        geometry: {
            type: 'Point',
            coordinates: [lng, lat],
        },
        place_name: 'Lat: ' + lat + ' Lng: ' + lng,
        place_type: ['coordinate'],
        properties: {},
        type: 'Feature',
    };
}

/** @function coordinatesGeocoder : calculate to return lat, lng values */
export function coordinatesGeocoder(query: string) {
    let coord1: number;
    let coord2: number;

    /*Degrees minutes seconds*/ let DMSmatches = query.match(`([0-9]{1,2})[:|°]([0-9]{1,2})[:|'|′]?([0-9]{1,2}(?:\.[0-9]+){0,1})?["|″]([N|S]), ([0-9]{1,3})[:|°]([0-9]{1,2})[:|'|′]?([0-9]{1,2}(?:\.[0-9]+){0,1})?["|″]([E|W])`);

    /*Decimal degrees*/ let DDmatches = query.match(`^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$`);

    /*Degrees decimal minutes*/ let DDMmatches = query.match(`^([NS])\\s*(\\d{1,2})°\\s*(\\d{1,2}\\.\\d+)',?\\s*([EW])\\s*(\\d{1,3})°\\s*(\\d{1,2}\\.\\d+)'$`);

    if (DMSmatches) {
        let [, d1, m1, s1, ns, d2, m2, s2, ew]: any = DMSmatches;
        let lat = parseInt(d1) + parseInt(m1) / 60 + parseFloat(s1) / 3600;
        lat = ns === 'S' ? -lat : lat;
        let lng = parseInt(d2) + parseInt(m2) / 60 + parseFloat(s2) / 3600;
        lng = ew === 'W' ? -lng : lng;
        coord1 = Number(lat);
        coord2 = Number(lng);
    } else if (DDmatches) {
        let [lat, lng] = query.split(', ');
        coord1 = Number(parseFloat(lat));
        coord2 = Number(parseFloat(lng));
    } else if (DDMmatches) {
        let [, ns, d1, m1, ew, d2, m2]: any = DDMmatches;
        let latitude: any = parseInt(d1) + parseFloat(m1) / 60;
        latitude *= ns === 'N' ? 1 : -1;
        let longitude: any = parseInt(d2) + parseFloat(m2) / 60;
        longitude *= ew === 'E' ? 1 : -1;
        coord1 = Number(parseFloat(latitude));
        coord2 = Number(parseFloat(longitude));
    } else if (!DMSmatches && !DDmatches && !DDMmatches) return null;

    const geocodes = [];
    // @ts-ignore
    if (coord1 < -90 || coord1 > 90) {
        // @ts-ignore
        geocodes.push(coordinateFeature(coord1, coord2));
    }
    // @ts-ignore
    if (coord2 < -90 || coord2 > 90) {
        // @ts-ignore
        geocodes.push(coordinateFeature(coord2, coord1));
    }

    if (geocodes.length === 0) {
        // @ts-ignore
        geocodes.push(coordinateFeature(coord1, coord2));
        // @ts-ignore
        geocodes.push(coordinateFeature(coord2, coord1));
    }

    return geocodes;
}

export const dummy_coordinates = {
    type: 'FeatureCollection',
    features: [
        {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: [
                    [101.94394629981002, 21.078921429384565],
                    [101.9458001467977, 21.081591311797098],
                    [101.9500720550771, 21.07907184656962],
                    [101.94721068255069, 21.077868504825332],
                    [103.94293877427128, 21.07816934117416],
                    [103.94451051410994, 21.07546179211363],
                    [103.94475232023854, 21.075612212799243],
                    [103.94475232023854, 21.075612212799243],
                ],
            },
            properties: {
                id: 'bec5997c-3b83-494f-9ba2-2a9bfb6cb4dd',
                type: 'line',
            },
        },
    ],
};

export const removeBoldCharacters = (str: any) => {
    const boldToNormal: any = {
        '𝗔': 'A',
        '𝗕': 'B',
        '𝗖': 'C',
        '𝗗': 'D',
        '𝗘': 'E',
        '𝗙': 'F',
        '𝗚': 'G',
        '𝗛': 'H',
        '𝗜': 'I',
        '𝗝': 'J',
        '𝗞': 'K',
        '𝗟': 'L',
        '𝗠': 'M',
        '𝗡': 'N',
        '𝗢': 'O',
        '𝗣': 'P',
        '𝗤': 'Q',
        '𝗥': 'R',
        '𝗦': 'S',
        '𝗧': 'T',
        '𝗨': 'U',
        '𝗩': 'V',
        '𝗪': 'W',
        '𝗫': 'X',
        '𝗬': 'Y',
        '𝗭': 'Z',
        '𝗮': 'a',
        '𝗯': 'b',
        '𝗰': 'c',
        '𝗱': 'd',
        '𝗲': 'e',
        '𝗳': 'f',
        '𝗴': 'g',
        '𝗵': 'h',
        '𝗶': 'i',
        '𝗷': 'j',
        '𝗸': 'k',
        '𝗹': 'l',
        '𝗺': 'm',
        '𝗻': 'n',
        '𝗼': 'o',
        '𝗽': 'p',
        '𝗾': 'q',
        '𝗿': 'r',
        '𝘀': 's',
        '𝘁': 't',
        '𝘂': 'u',
        '𝘃': 'v',
        '𝘄': 'w',
        '𝘅': 'x',
        '𝘆': 'y',
        '𝘇': 'z',
    };
    let result = '';
    for (let char of str) {
        result += boldToNormal[char] || char;
    }
    return result;
};

export const textToHtmlWithBreaks = (rawText: string): string => {
    if (!rawText) return '';

    // Escape HTML special characters
    const escapedText = rawText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    // Replace newline characters with <br> tags
    const htmlText = escapedText.replace(/\r?\n/g, '<br>');

    return htmlText;
};

export const priceFromToText = (text: string): number[] => {
    if (!text) return [0, 0];
    // Match numbers with optional commas and decimals
    const matches = text.match(/\d{1,3}(,\d{3})*(\.\d+)?/g);
    if (!matches || matches.length < 2) {
        return [0, 0];
    }
    // Convert matched strings to numbers by removing commas
    const numbers: number[] = matches.map((num) => parseFloat(num.replace(/,/g, '')));
    return numbers.slice(0, 2);
};

export const normalizeVietnamese = (str: string): string => {
    if (!str) return '';

    // Normalize to NFD (decomposed form)
    const normalized = str.normalize('NFD');

    // Remove diacritical marks
    const withoutDiacritics = normalized.replace(/[\u0300-\u036f]/g, '');

    // Replace special Vietnamese characters đ and Đ
    const replaced = withoutDiacritics.replace(/đ/g, 'd').replace(/Đ/g, 'D');

    return replaced;
};

export const currencyFormat = (price: number, currency: string): string => {
    if (currency === 'USD') return `$${price.toLocaleString().replace(/,/g, '.')}`;
    if (currency === 'VND') return `${price.toLocaleString().replace(/,/g, '.')}đ`;
    return `${price} ${currency}`;
};
